import React, { ChangeEvent, InputHTMLAttributes } from 'react';
import { Switch } from '@mui/material';
import { highContrastMode } from '../../utils/highContrastChecker';
import DisabledBadge from '../DisabledBadge/DisabledBadge.component';

interface OneSwitchProps {
  disableRipple?: boolean;
  disabled?: boolean;
  defaultChecked?: boolean;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  name?: string;
  className?: string;
  checked?: boolean;
  color?: 'primary' | 'secondary' | 'default' | undefined;
  tooltipTitle?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  ariaLabel?: string;
}

const border = highContrastMode ? 'solid 1px white' : 'none';

const SwitchOne: React.FC<OneSwitchProps> = (props) => {
  return (
    <DisabledBadge
      badgeHidden={!props.disabled}
      transform={{ left: props.checked || props.defaultChecked ? '-36px' : '-20px', top: '20px' }}
      width={'12px'}
      height={'12px'}
    >
      <Switch
        {...props}
        sx={{
          '& .MuiSwitch-switchBase': {
            '& + .MuiSwitch-track': {
              border: border,
              opacity: '1',
            },
            '&.Mui-checked': {
              '& .MuiSwitch-thumb:before': {
                backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="13" width="13" viewBox="0 0 32 32"><path fill="white" d="M 28.28125 6.28125 L 11 23.5625 L 3.71875 16.28125 L 2.28125 17.71875 L 10.28125 25.71875 L 11 26.40625 L 11.71875 25.71875 L 29.71875 7.71875 Z"/></svg>')`,
              },
            },
            '&.Mui-disabled + .MuiSwitch-track': {
              opacity: highContrastMode ? '1' : '0.12',
            },
          },
          '& .MuiSwitch-thumb': {
            backgroundColor: props.disabled ? '#6F707B' : '#3F51B5',
            border: border,
            '&::before': {
              content: "''",
              position: 'absolute',
              width: '100%',
              height: '100%',
              left: 0,
              top: 0,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="13" width="13" viewBox="0 0 32 32"><path fill="white" d="M 7.21875 5.78125 L 5.78125 7.21875 L 14.5625 16 L 5.78125 24.78125 L 7.21875 26.21875 L 16 17.4375 L 24.78125 26.21875 L 26.21875 24.78125 L 17.4375 16 L 26.21875 7.21875 L 24.78125 5.78125 L 16 14.5625 Z" /></svg>')`,
            },
          },
          '& .MuiSwitch-track': {
            backgroundColor: props.disabled && !highContrastMode ? 'D3D3D3' : '#AAB4BE',
            border: border,
            borderRadius: 22 / 2,
            height: 15,
          },
        }}
      />
    </DisabledBadge>
  );
};

export default SwitchOne;
